import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseWidgetComponent } from '../widget/base/base-widget';
import { IBaseWidgetConfig } from '../widget/base/widget-list';
import * as THREE from 'three';
import { DxButtonModule } from 'devextreme-angular';
import { DoorRearBottom3DPart } from './partsModels/door-rear-bottom-part';
import { Slide3DPart } from './partsModels/slide-part';
import { Machine3DPart } from './partsModels/machine-part';
import { PortaFront3DPart } from './partsModels/porta-front-part';
import { Vetro3DPart } from './partsModels/vetro-part';
import { Lightbar3DPart } from './partsModels/lightbar-part';
import { Telecamera3DPart } from './partsModels/telecamera-part';
import { DoorRearTop3DPart } from './partsModels/door-rear-top-part';
import { Tramoggia3DPart, TramoggiaState } from './partsModels/tramoggia-part';
import { CoverBack3DPart } from './partsModels/cover-back-part';
import { CoverFront3DPart } from './partsModels/cover-front-part';
import { VetroLeft3DPart } from './partsModels/vetro-left-part';
import { VetroRight3DPart } from './partsModels/vetro-right-part';
import { Schede3DPart } from './partsModels/schede-part';
import { OrbitControls } from 'three/examples/jsm/Addons.js';
import { WidgetDataService } from '../widget/data/widget-data.service';
import { CommonModule } from '@angular/common';
import { combineLatest, Observable, of, Subject, Subscription, takeUntil } from 'rxjs';
import { IMachineConfig, MachineConfigUtils } from './machine-config-utils';
import { RemoteDataWrapperService } from '../../../../shared/services/remote-data/remote-data-wrapper.service';
import { DashboardDataService } from '../../data/dashboard-data.service';
import { ToastrService } from 'ngx-toastr';
import { MachineFunction } from 'src/app/shared/services/remote-data/machine-one.service';
import { AuthHelperService } from 'src/app/core/auth/auth-helper.service';
import { confirm } from 'devextreme/ui/dialog';
import { TranslateWithFallbackPipe } from 'acl-cloud-lib';
import { MachineInfoMainService } from '../../../../shared/services/machine-info.service';

export interface IMachineViewWidgetConfig extends IBaseWidgetConfig {
  // Consist only IBasicWidgetConfig properties. But can be extended in future.
  // and maintains consistency naming in all widgets (project).
}

@Component({
  selector: 'app-machine-view',
  standalone: true,
  imports: [CommonModule, DxButtonModule],
  templateUrl: './machine-view.component.html',
  styleUrl: './machine-view.component.scss'
})
export class MachineViewWidgetConponent extends BaseWidgetComponent<IMachineViewWidgetConfig> implements OnDestroy, OnInit {

  @ViewChild('canvas', { static: true }) canvasRef!: ElementRef;

  public isArrowAnimationRunning: boolean = false;

  private _unsubscribeVariables = new Subject<void>();
  private _scene!: THREE.Scene;
  private _renderer!: THREE.WebGLRenderer;
  private _camera!: THREE.PerspectiveCamera;
  private _controls!: OrbitControls;
  private _evenOdd = 0;
  private _doneCameras = 0;
  private _slides: Slide3DPart[] = [];
  private _tramoggia: Tramoggia3DPart[] = [];
  private _parts: any[] = [];
  private _oldMachineName?: string;

  private _machineConfig: IMachineConfig = {
    name: 'Feinx',
    type: 'Fenix',
    sections: [],
    slidesCount: 0
  }

  private _availableActions: MachineFunction[] = [];
  private _emptyingPropertyId?: number;
  protected emptyingRole?: string;
  protected isEmpting: boolean = false;
  protected isSelecting: boolean = false;

  constructor(
    widgetDataService: WidgetDataService<IMachineViewWidgetConfig>,
    remoteDataWrapperService: RemoteDataWrapperService,
    private readonly _dashboardDataSvc: DashboardDataService,
    private readonly _toastr: ToastrService,
    private readonly _authHelperSvc: AuthHelperService,
    private readonly _translate: TranslateWithFallbackPipe,
  ) {
    super(widgetDataService, remoteDataWrapperService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this._dashboardDataSvc.widgetInitialized();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this._unsubscribeVariables.next();
    this._unsubscribeVariables.complete();
    this._dashboardDataSvc.widgetDestroyed();
  }

  protected override setOptions(options: IMachineViewWidgetConfig | undefined): void {
    if (options) {
      if (options.machineName && options.machineName !== this.options?.machineName) {
        this.options = {...options};
        this._initCollectionMachineConfiguration();
      } else {
        this.options = {...options};
      }
    }
  }

  protected override supplierStateChnged(val: boolean): void {
    if (!val) {
      [...this._slides, ...this._tramoggia].forEach(part => {
        part.setState(TramoggiaState.DISABLED, this._scene);
      });
    }
  }

  protected async setEmptyOnSupplier(val: boolean): Promise<void> {
    if (this._emptyingPropertyId && this.options?.machineName) {
      const res = await this.remoteDataWrapperService.setPropertyOnSupplier(this.options.machineName, this._emptyingPropertyId, val);

      if (res) {
        this._toastr.success('Operation done.');
        return;
      }
    }

    this._toastr.error('Operation failed.');
  }

  // next recreate to for open door
  // public toogleAnimation(): void {
  //   if (this.isArrowAnimationRunning) {
  //     this._slides.forEach((slide) => slide.stopArrowAnimation(this._scene));
  //     this._tramoggia.forEach((tramoggia) => tramoggia.toogleShowAnimation());
  //     this.isArrowAnimationRunning = false;
  //   } else {
  //     this._slides.forEach((slide) => slide.playArrowAnimation(this._scene));
  //     this._tramoggia.forEach((tramoggia) => tramoggia.toogleShowAnimation());
  //     this.isArrowAnimationRunning = true;
  //   }
  // }

  startConfirmDialog(): void {
    const result = confirm(this._translate.transform('start-machine-question'), this._translate.transform('confirmation'));
    result.then((dialogResult) => {
      if (dialogResult) {
        this.doCommand('SmSelectCmd');
      }
    });
  }

  protected async doCommand(cmdName: 'SmStopCmd' | 'SmSelectCmd'): Promise<void> {
    const cmd = this._availableActions.find(cmd => cmd.name === cmdName);
    if (cmd) {
      if (this.options?.machineName) {
        const res = await this.remoteDataWrapperService.invokeOnSupplierById(this.options.machineName, cmd.id, null);

        if (res) {
          this._toastr.success(this._translate.transform('operation-done'));
        } else {
          this._toastr.error(this._translate.transform('operation-failde'));
        }
      }
    } else {
      this._toastr.error(this._translate.transform('operation-failde'));
    }

  }

  public toggleOpenTopDoor(): void {
    this._parts[1].toggleOpen();
  }

  protected getCmdRole(cmd: string): string | undefined {
    return this._availableActions.find(c => c.name === cmd)?.role;
  }

  protected isFenixActionEnabled(role: string | undefined): Observable<boolean> {
    if (!role) return of(false);
    return this._authHelperSvc.isFenixActionEnabled(role);
  }

  private _combineSub?: Subscription;
  private _subs: Subscription[] = [];

  private _initCollectionMachineConfiguration(): void {
    if (this.options && this._oldMachineName && this.options.machineName !== this._oldMachineName) {
      this.remoteDataWrapperService.watchRemoteDataUpdates(this._oldMachineName, false);
      this.unSubscriber.unsubscribe();
      this._oldMachineName = this.options.machineName;
    }


    if (this.options && this.options.machineName){
      this.remoteDataWrapperService.watchRemoteDataUpdates(this.options.machineName, true);

      const machineStructureRaw$ = this.remoteDataWrapperService.getMachineStructureRaw(this.options.machineName ?? '');
      const machineStructure$ = this.remoteDataWrapperService.getMachineStructure(this.options.machineName ?? '');
      
      this._combineSub?.unsubscribe();
      this._combineSub = combineLatest([machineStructure$, machineStructureRaw$]).pipe(
        takeUntil(this.unSubscriber)
      ).subscribe(([machineStructure, machineStructureRaw]) => {
        if (machineStructure && machineStructureRaw && machineStructureRaw !== '{}') {
          this._machineConfig = MachineConfigUtils.resolveMachineConfigurationFromJson(machineStructureRaw, machineStructure);
          this.initializeScene();
          this.initializeCamera();
          this.initializeRenderer();
          this.initializeLighting();
          this.initializeControls();
          this.createBaseModel();
          this.animate();
          this.onResize();

          try {
            this._availableActions = [];
            const parsed = JSON.parse(machineStructureRaw);
            Object.keys(parsed.MachineOne).forEach(key => {
              if (typeof parsed.MachineOne[key] === 'object' && 
                Object.keys(parsed.MachineOne[key]).includes('_T') && 
                parsed.MachineOne[key]['_T'] === 'CMD'
              ) {
                this._availableActions.push({id: parsed.MachineOne[key]._ID, name: key, args: null, role: parsed.MachineOne[key].Role})
              }
            });

            this._subs.forEach(sub => sub.unsubscribe());
            this._subs = [];

            this._subs.push(
              machineStructure.MachineOne.EmptyingOnOff.pipe(takeUntil(this.unSubscriber)).subscribe((val: boolean) => {
                this.isEmpting = val;
              })
            );

            this._subs.push(
              machineStructure.MachineOne.IsSelecting.pipe(takeUntil(this.unSubscriber)).subscribe((val: boolean) => {
                this.isSelecting = val;
              })
            );

            this._emptyingPropertyId = parsed.MachineOne.EmptyingOnOff._ID;
            this.emptyingRole = parsed.MachineOne.EmptyingOnOff.Role;
          } catch (e) {
            this._availableActions = [];
          }
        }
      });
    }
  }

  private initializeScene(): void {
    if (this._scene) {
      this._scene.clear();
      this._scene = new THREE.Scene();
      this._scene.background = new THREE.Color(0x363640);
      this._scene.rotation.x = -(Math.PI / 2);
    } else {
      this._scene = new THREE.Scene();
      this._scene.background = new THREE.Color(0x363640);
      this._scene.rotation.x = -(Math.PI / 2);
    }
  }

  private initializeCamera(): void {
    if (!this._camera){
      this._camera = new THREE.PerspectiveCamera(
        50,
        this.canvasRef.nativeElement.clientWidth / this.canvasRef.nativeElement.clientHeight,
        0.5,
        5000000
      );
    }
  }

  private initializeRenderer(): void {
    if (!this._renderer){
      this._renderer = new THREE.WebGLRenderer({ antialias: true });
      this._renderer.setSize(this.canvasRef.nativeElement.clientWidth, this.canvasRef.nativeElement.clientHeight);
      document.body.appendChild(this._renderer.domElement);
      this.canvasRef.nativeElement.appendChild(this._renderer.domElement);
    }
  }

  private initializeLighting(): void {
    // Add ambient light for uniform lighting
    const ambientLight = new THREE.AmbientLight(0x404040, 20); // soft white light
    this._scene.add(ambientLight);

    // Add directional light from the front
    const frontLight = new THREE.DirectionalLight(0xffffff, 1);
    frontLight.position.set(80, 80, 80);
    this._scene.add(frontLight);

    // Add directional light from the back
    const backLight = new THREE.DirectionalLight(0xffffff, 1);
    backLight.position.set(-80, 80, -80);
    this._scene.add(backLight);
  }

  private initializeControls(): void {
    this._controls = new OrbitControls(this._camera, this._renderer.domElement);
    this._controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    this._controls.dampingFactor = 0.25;
    this._controls.screenSpacePanning = false;
    this._controls.maxPolarAngle = Math.PI;
  }

  private _slideSubs: Array<Subscription> = [];

  private createBaseModel(): void {
    // Clear all subscriptions for variables (SignalR)
    if (!this._unsubscribeVariables.closed) {
      this._unsubscribeVariables.next();
      this._unsubscribeVariables.complete();
    }

    // Create base model for machine
    if (this._machineConfig.type === 'Hyperion') {
      this._parts = [
        new Machine3DPart('Hyperion', false, this._machineConfig.slidesCount),
        new PortaFront3DPart('Hyperion', false, this._machineConfig.slidesCount),
        new DoorRearBottom3DPart('Hyperion', false, this._machineConfig.slidesCount),
        new VetroLeft3DPart('Hyperion', false, this._machineConfig.slidesCount),
        new VetroRight3DPart('Hyperion', false, this._machineConfig.slidesCount)
        // "hyperion2\\luci\\LB-top.obj"
        // "hyperion2\\luci\\LB-center.obj"
        // "hyperion2\\luci\\LB-bottom.obj"
        // "hyperion2\\luci\\LF-top.obj"
        // "hyperion2\\luci\\LF-center.obj"
        // "hyperion2\\luci\\LF-bottom.obj"

        //"parts\\scivoli\\Divisore.obj"
        // "parts\\scivoli\\Soffio-numbers.obj"                                                      
      ];
    } else if (this._machineConfig.type === 'Optica') {
      this._parts = [
        new Machine3DPart('Optica', false, this._machineConfig.slidesCount),
        new CoverBack3DPart('Optica', false, this._machineConfig.slidesCount),
        new CoverFront3DPart('Optica', false, this._machineConfig.slidesCount),
        // "macchina2\\luci\\LB-top.obj"
        // "macchina2\\luci\\LB-center.obj"
        // "macchina2\\luci\\LB-bottom.obj"
        // "macchina2\\luci\\LF-top.obj"
        // "macchina2\\luci\\LF-center.obj"
        // "macchina2\\luci\\LF-bottom.obj"

        // "parts\\scivoli\\Divisore.obj"                                                              
        // "parts\\scivoli\\Soffio-numbers.obj"
      ];
    } else {
      this._parts = [
        new Machine3DPart('Fenix', false, this._machineConfig.slidesCount),
        new DoorRearTop3DPart('Fenix', false, this._machineConfig.slidesCount),
        new PortaFront3DPart('Fenix', false, this._machineConfig.slidesCount),
        new Vetro3DPart('Fenix', false, this._machineConfig.slidesCount),
        new DoorRearBottom3DPart('Fenix', false, this._machineConfig.slidesCount),
        new Lightbar3DPart('Fenix', false, this._machineConfig.slidesCount)
        // "macchina2\\luci\\LB-top.obj"
        // "macchina2\\luci\\LB-center.obj"
        // [x] "macchina2\\luci\\LB-bottom.obj"
        // "macchina2\\luci\\LF-top.obj"
        // "macchina2\\luci\\LF-center.obj"
        // "macchina2\\luci\\LF-bottom.obj"

        // "parts\\scivoli\\Divisore.obj"
        // "parts\\scivoli\\Soffio-numbers.obj"
      ];
    }

    this._parts.forEach((part) => {
      part.load(this._scene);
    });

    // Create all slides, cameras and tramoggia
    let slide_position = 0;

    this._slideSubs.forEach(sub => sub.unsubscribe());
    this._slideSubs = [];

    this._machineConfig.sections.forEach((section) => {
      section.slides.forEach((slide) => {
        // Create slide
        const slidePart = new Slide3DPart(slide_position, slide.isHalfSlide, this._machineConfig.type);
        slidePart.load(this._scene);
        slidePart.setState(slide.state, this._scene);
        slidePart.createPath();
        this._slides.push(slidePart);

        // Create tramoggia
        const tramoggiaPart = new Tramoggia3DPart(slide_position, slide.isHalfSlide, this._machineConfig.type);
        tramoggiaPart.load(this._scene);
        tramoggiaPart.setState(slide.state, this._scene);
        tramoggiaPart.setPercentageFilled(section.hopperAnalogLevel, this._scene);
        this._tramoggia.push(tramoggiaPart);

        // create subscribes for slides and tramoggia variables
        // TODO: After add variables for state of slides and tramoggia set
        this._slideSubs.push(slide.isRunnung$.pipe(takeUntil(this._unsubscribeVariables)).subscribe(fill => {
          if (fill) {
            slidePart.setState(TramoggiaState.RUNNING, this._scene);
            tramoggiaPart.setState(TramoggiaState.RUNNING, this._scene);
          } else {
            slidePart.setState(TramoggiaState.DISABLED, this._scene);
            tramoggiaPart.setState(TramoggiaState.DISABLED, this._scene);
          }
        }));

        this._slideSubs.push(slide.isPaused$.pipe(takeUntil(this._unsubscribeVariables)).subscribe(fill => {
          if (fill) {
            slidePart.setState(TramoggiaState.PAUSED, this._scene);
            tramoggiaPart.setState(TramoggiaState.PAUSED, this._scene);
          }
        }));

        this._slideSubs.push(section.hopperAnalogLevel$.pipe(takeUntil(this._unsubscribeVariables)).subscribe(fill => {
          tramoggiaPart.setPercentageFilled(fill, this._scene);
        }));

        // Create cameras
        if (this._machineConfig.type === 'Fenix') {
          if (this._doneCameras > 1) {
            this._doneCameras = 0;
          }

          if (slide.isHalfSlide) {
            if (this._doneCameras === 0) {
              this._doneCameras = 1;
              slide.cameras.forEach(camera => {
                const cameraPart = new Telecamera3DPart(camera.position, slide_position, this._machineConfig.type);
                cameraPart.load(this._scene);
                const schede = new Schede3DPart(slide_position, this._machineConfig.type);
                schede.load(this._scene);
              });
            } else {
              this._doneCameras++;
            }
          } else {
            this._doneCameras = 0;
            slide.cameras.forEach((camera: any) => {
              const cameraPart = new Telecamera3DPart(camera.position, slide_position, this._machineConfig.type);
              cameraPart.load(this._scene);
              const schede = new Schede3DPart(slide_position, this._machineConfig.type);
              schede.load(this._scene);
            });
          }
        } else {
          slide.cameras.forEach(camera => {
            const cameraPart = new Telecamera3DPart(camera.position, slide_position, this._machineConfig.type);
            cameraPart.load(this._scene);
          });
        }
        slide_position += slide.isHalfSlide ? 0.5 : 1;
        this._evenOdd++;
      });
    });

    setTimeout(() => {
      this.adjustCameraAndControls();
    }, 10)
  }

  private adjustCameraAndControls(): void {
    const box = new THREE.Box3().setFromObject(this._scene);
    const center = box.getCenter(new THREE.Vector3());
  
    // Set the camera position 49.285, 42.512, 22.629
    this._camera.position.set(center.x + 49.285, center.y + 42.512, center.z + 22.629); // Adjust the z value as needed
    this._camera.lookAt(center);
  
    // Set the orbit controls target
    if (this._machineConfig.type === 'Hyperion'){
      this._controls.target.set(center.x + 10, center.y, center.z);
    } else {
      this._controls.target.set(center.x, center.y, center.z);
    }

    this._controls.update();

    if (this._machineConfig.type === 'Optica') {
      this._scene.position.y += 13;
    } else if (this._machineConfig.type === 'Hyperion') {
      this._scene.position.y += 15;
    } else if (this._machineConfig.type === 'Fenix') {
      this._scene.position.y += 15;
    }
  }

  private animate(): void {
    requestAnimationFrame(() => this.animate());

    // Update arrow position and orientation
    const time = (Date.now() % 10000) / 10000; // Loop over 10 seconds
    this._slides.forEach((slide) => slide.updateArrow(time));

    this._controls.update();
    this._renderer.render(this._scene, this._camera);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._camera.aspect = this.canvasRef.nativeElement.clientWidth / this.canvasRef.nativeElement.clientHeight;
      this._camera.updateProjectionMatrix();
      this._renderer.setSize(this.canvasRef.nativeElement.clientWidth, this.canvasRef.nativeElement.clientHeight);
    }, 300);
  }

}
